<script>
    import R, {LOADER} from "../lib/requests";
    import {HOTEL_TYPE} from "../lib/constants.js";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";

    export let hotelId = null;
    export let closeCallback;

    let hotel = null;

    const initialize = () => {
        if (hotelId == 0) {
            hotel = {
                id: 0,
                code: '',
                name: '',
                email: '',
                location: '',
                url: '',
                contact_list_id: '',
                points: 0,
                is_active: 1,
            }
            setFocusTo('hotelName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            hotel = result;
            hotel.type = ~~hotel.type;
            setFocusTo('hotelName');
        };

        const onFailure = err => {
        };

        R.handle(R.hotel.details, hotelId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            if (hotelId == 0) {
                Notifier.showMessage("Hotel created");
            } else {
                Notifier.showMessage("Hotel updated");
            }
            close(result);
        }

        const onFailure = err => {

        };


        hotel.name = hotel.name.trim();
        hotel.code = hotel.code.trim();

        if (!hotel.name) {
            Notifier.showError("Type the name of the hotel");
            setFocusTo("hotelName");
            return;
        }

        let action = hotelId == 0 ? 'create' : 'edit';
        R.handle(R.hotel[action], hotel, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = param => {
        hotel = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    initialize();
</script>

{#if hotel}
    <Modal title="Hotel" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="hotelName" bind:value="{ hotel.name }">
            </div>
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" bind:value="{ hotel.email }">
            </div>
            <div class="form-group">
                <label>Type</label>
                <select class="form-select" bind:value="{ hotel.type }">
                    <option value="{ HOTEL_TYPE.HOTEL }">Hotel</option>
                    <option value="{ HOTEL_TYPE.VILLA }">Villa</option>
                </select>
            </div>
            <div class="form-group">
                <label>Location</label>
                <input type="text" class="form-control" bind:value="{ hotel.location }">
            </div>
            <div class="form-group">
                <label>Url</label>
                <input type="text" class="form-control" bind:value="{ hotel.url }" placeholder="https://hotel-url.gr">
            </div>
            <div class="row">
                <div class="col-3 form-group">
                    <label>Short</label>
                    <input type="text" class="form-control" bind:value="{ hotel.short }">
                </div>
                <div class="col-3 form-group">
                    <label>Points</label>
                    <input type="number" class="form-control" bind:value="{ hotel.points }">
                </div>
                <div class="col-6 form-group">
                    <label>List Id</label>
                    <input type="text" class="form-control" bind:value="{ hotel.contact_list_id }">
                </div>
            </div>
            <div class="form-group">
                <label>Code</label>
                <input type="text" class="form-control" bind:value="{ hotel.code }">
            </div>
            <div class="form-group">
                <Checkbox label="Active hotel" bind:checked="{ hotel.is_active }"/>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>
{/if}